class WellnubService {
  constructor(axios) {
    this.axios = axios;
  }
}

export default WellnubService;
